/**
 * Shouldn't use this for anything important!
 * Simple deep merge function for objects
 *
 * @param {Object} a
 * @param {Object} b
 * @returns {Object}
 */
function deepmerge(a, b) {
    const isObject = obj => obj && typeof obj === 'object';
    const isArray = obj => obj && typeof obj === 'object' && obj.constructor === Array;
    if (!isObject(a) || !isObject(b)) {
        return b;
    }
    if (isArray(a) || isArray(b)) {
        return b;
    }
    const keys = Object.keys({ ...a, ...b });
    const result = {};
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const sourceValue = a[key];
        const targetValue = b[key];
        if (isObject(sourceValue) && isObject(targetValue)) {
            result[key] = deepmerge(sourceValue, targetValue);
        }
        else {
            result[key] = targetValue !== undefined ? targetValue : sourceValue;
        }
    }
    return result;
}
export default deepmerge;
